<template>
  <div v-loading="loading" class="ec-line042">
    <el-breadcrumb separator="/" class="mt-7">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('ec-line042.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <the-heading>{{ $t('ec-line042.title') }}</the-heading>
    <div v-if="purchases.length">
      <purchase-information :data="purchases" />
      <el-pagination
        v-if="pagination.total_items > form.pagination.record_limit"
        layout="prev, pager, next"
        :page-size="form.pagination.record_limit"
        :pager-count="3"
        :total="pagination.total_items"
        :current-page="pagination.page"
        class="mt-10 pb-5 lg:pb-0 mx-auto"
        background
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <p class="text-center" v-else>{{ $t('common.messages.noPurchases') }}</p>

    <div class="w-full mt-5 lg:mt-10 pb-5 lg:pb-10 flex justify-center">
      <el-button class="cancel-btn align-center font-bold text-base lg:text-lg" @click="onCancel">
        {{ $t('common.action.cancel') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import deliveryNoteMixin from '@/mixins/deliveryNote'
import { OrderService } from '@/services'
import PurchaseInformation from '@/components/ec-line042/PurchaseInformation.vue'

export default {
  components: { PurchaseInformation, TheHeading },
  mixins: [BreadcrumbMixin, deliveryNoteMixin],
  data() {
    return {
      loading: false,
      purchases: [],
      pagination: {},
      form: {
        pagination: {
          page: 1,
          record_limit: 10,
        },
      },
    }
  },

  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
  },

  watch: {
    'form.pagination.page'() {
      this.fetchData()
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      try {
        this.loading = true
        const params = {
          page: this.form.pagination.page,
          record_limit: this.form.pagination.record_limit,
        }

        const { data } = await OrderService.getOrderList(params)
        const { pagination, items } = data
        this.purchases = items
        this.pagination = pagination
      } finally {
        this.loading = false
      }
    },
    onCancel() {
      this.$router.push({
        path: this.$routePage.EC_LINE009,
      })
    },
    handleCurrentChange(page) {
      this.form.pagination.page = page
    },
  },

  metaInfo() {
    return {
      title: this.$t('ec-line042.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line042.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line042.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line042.scss';
</style>
